import BaseService from '@/ecm/common/BaseService.js';
import Utils from '@/ecm/common/Utils.js';

class DigitalSignatureService {
  baseUrl = 'digital-signature';

  getById = (id) => BaseService.get({ url: `${this.baseUrl}/${id}` });
  getGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-grid`);
  getList = () => BaseService.get({ url: `${this.baseUrl}/get-list` });
  getProviderList = () => BaseService.get({ url: `${this.baseUrl}/get-provider-list` });
  getSignatureImage = (id) => BaseService.get({ url: `${this.baseUrl}/image/${id}` });
  delete = (id) => BaseService.delete({ url: `${this.baseUrl}/${id}` });
  save = (digitalSignature) => BaseService.post({ url: `${this.baseUrl}`, data: digitalSignature });
  update = (digitalSignature) => BaseService.put({ url: `${this.baseUrl}`, data: digitalSignature });
}

export default new DigitalSignatureService();
